export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const IS_PROD = process.env.NEXT_PUBLIC_ENVIRONMENT === "production";
export const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL;
export const GTAG = process.env.NEXT_PUBLIC_GTAG;
export const SITEMAP_URL = `${process.env.NEXT_PUBLIC_WEBSITE_URL}/sitemap.xml`;
export const GOOGLE_ANALYTICS_TAG_ID =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TAG_ID ?? "";
export const COMPANY_LOGO = process.env.NEXT_PUBLIC_LOGO_URL ?? "";
export const DEFAULT_PAGE_REVALIDATE = IS_PROD ? 3600 : 60;

const envLocation = process.env.NEXT_PUBLIC_DEFAULT_LOCATION?.split(",");
export const defaultLocation = envLocation
  ? { lat: Number(envLocation[0]), lng: Number(envLocation[1]) }
  : {
      lat: 41.349801,
      lng: 69.2519935,
    };

export const activeOrderStatuses = ["new", "accepted", "ready", "on_a_way"];
export const finishedOrderStatuses = ["delivered", "canceled"];

export const redirectNotificationTypesMap: Record<string, string> = {
  order: "orders",
  parcelorder: "parcels",
  blog: "news",
};

export const externalPayments = [
  "stripe",
  "razorpay",
  "paystack",
  "mollie",
  "moyasar",
];
export const internalPayments = ["cash", "wallet"];
export const storyTiming = 10;

export const cardColors = ["#B9CCDF80", "#E3CDE180"];

export const COMPANY_INFO = {
  contactNo: "+61 405678859",
  address: "Unit 32/191B McCredie Road, Smithfield NSW 2164",
  email: "info@essentialsint.com",
};
